import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';
// import config from '@plone/volto/registry';
import { Grid } from 'semantic-ui-react';
import { Icon } from '@plone/volto/components';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { flattenToAppURL } from '@plone/volto/helpers';
import rightarrow from '@plone/volto/icons/right-key.svg';

const messages = defineMessages({
  startTime: {
    id: '{date} -tik',
    defaultMessage: '{date} -tik',
  },
});

const AgendaListing = ({
  items,
  moreLinkText,
  moreLinkUrl,
  header,
  headerUrl,
  headerTag,
  isEditMode,
}) => {
  const intl = useIntl();

  const lang = useSelector((state) => state.intl.locale);
  moment.locale(lang);
  let moreLink = null;
  let moreHref = moreLinkUrl?.[0]?.['@id'] || '';
  const HeaderTag = headerTag ? headerTag : 'h3';
  if (isInternalURL(moreHref)) {
    moreLink = (
      <ConditionalLink to={flattenToAppURL(moreHref)} condition={!isEditMode}>
        {moreLinkText || moreHref}
      </ConditionalLink>
    );
  } else if (moreHref) {
    moreLink = <a href={moreHref}>{moreLinkText || moreHref}</a>;
  }

  let headerLink = null;
  let headerHref = headerUrl?.[0]?.['@id'] || '';
  if (isInternalURL(headerHref)) {
    headerLink = (
      <ConditionalLink to={flattenToAppURL(headerHref)} condition={!isEditMode}>
        {header || headerHref}
      </ConditionalLink>
    );
  } else if (headerHref) {
    moreLink = <a href={headerHref}>{moreLinkText || headerHref}</a>;
  }
  return (
    <>
      <HeaderTag className="listing-header">
        {headerLink ? headerLink : header}
      </HeaderTag>
      <div class="container">
        {items.map((item) => (
          <Grid columns={4} key={item['@id']}>
            <Grid.Column width={2}>
              {item.event_whole_day ? (
                <p>
                  <span className="day">{moment(item.start).format('L')}</span>
                  {/* <span className="day">
                    {intl.formatMessage(messages.startTime, {
                      date: moment(item.start).format('L'),
                    })}
                  </span> */}
                </p>
              ) : (
                <p>
                  <span className="day">{moment(item.start).format('L')}</span>
                  {/* {intl.formatMessage(messages.startTime, {
                    date: moment(item.start).format('L'),
                  })} */}
                  &nbsp;
                  <span className="hour">
                    {moment(item.start).format('HH')}:
                    {moment(item.start).format('mm')}
                  </span>
                </p>
              )}
            </Grid.Column>
            <Grid.Column width={2}>{item.location}</Grid.Column>
            <Grid.Column width={8}>
              <h3>
                <ConditionalLink item={item} condition={!isEditMode}>
                  <Icon name={rightarrow} />
                  {item.title ? item.title : item.id}
                </ConditionalLink>
              </h3>
            </Grid.Column>
          </Grid>
        ))}
      </div>
      {moreLink && <div className="listing-footer">{moreLink}</div>}
    </>
  );
};
AgendaListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default AgendaListing;
